import React from 'react';
import { useRecoilValue } from 'recoil';
import VinChecker from './components/vinChecker/VinChecker';
import { useLabels } from './hooks/useLabels';
import { labelsAtom } from './store/atoms/labels';

const App = (): JSX.Element => {
	const labelsStore = useRecoilValue(labelsAtom);
	const labels = useLabels(
		{ useFallbacks: true, useWrappedFallbacks: true },
		{ content: labelsStore }
	);
	return <VinChecker {...labels} />;
};

export default App;
